import React, { useEffect, useState } from "react";
import PromoTemplate from "../../components/PromoTemplate";
import LiveJoinNotification from "../../components/LiveJoinNotification";
import { db } from "../../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";

function HomemPage() {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    async function load() {
      const ref = doc(db, "campaigns", "clubdohomem");
      const snap = await getDoc(ref);
      if (snap.exists()) setConfig(snap.data());
    }
    load();
  }, []);

  if (!config) return <div>Carregando...</div>;

  // 🔥 Override exclusivo da página de mulher
  const finalConfig = {
    ...config,
    
    showTopBar: true,
    showDiscountBadge: true,
    showSocialProof: true,
    showSocialProoffeminino: false,
    showSpotsSection: true,
    showBenefitsSection: true,
    logofinalfeminino: false,
  };


  return (
    <>
      {/* Notificação de Prova Social */}
      {/* <LiveJoinNotification /> */}

      {/* Página principal */}
      <PromoTemplate config={finalConfig} />
    </>
  );
}

export default HomemPage;
